import React from 'react'
import PropTypes from 'prop-types'
import { createTelLink, createMailtoLink } from '@helpers/LinkHelper.js'
import { ReactComponent as Marker } from '@assets/svgs/icons/marker.svg'
import { ReactComponent as Phone } from '@assets/svgs/icons/phone.svg'
import { ReactComponent as Email } from '@assets/svgs/icons/email.svg'
import classnames from 'classnames'
import './BranchContactDetails.module.scss'

const BranchContactDetails = ({ address, phone, email, forSearch }) => {
  const telLink = createTelLink(phone)
  const mailtoLink = createMailtoLink(email)

  return (
    <div styleName={classnames('contactDetails', { 'noTopBorder': forSearch })}>
      <div styleName='row'>
        <Marker styleName='icon' />
        <div styleName='text'>{address}</div>
      </div>
      <div styleName='row'>
        <Phone styleName='icon' />
        <div styleName='text'>
          <a href={telLink}>{phone}</a>
        </div>
      </div>
      <div styleName='row'>
        <Email styleName='icon' />
        <div styleName='text'>
          <a styleName='link' href={mailtoLink}>{email}</a>
        </div>
      </div>
    </div>
  )
}

BranchContactDetails.propTypes = {
  address: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  style: PropTypes.object
}

export default BranchContactDetails



// WEBPACK FOOTER //
// ./src/components/BranchContactDetails/BranchContactDetails.js